import React, {useState, useEffect} from 'react'
import { useParams } from 'react-router-dom'
import db from '../firebase'
import { Loader } from '../components/Loader'
import { Button, ListGroup, Badge, Image } from 'react-bootstrap'
import '../App.css'
import { LinkContainer } from 'react-router-bootstrap'
import Skeleton from '@material-ui/lab/Skeleton';
import GitHubIcon from '@material-ui/icons/GitHub';
import { OpenInNewRounded } from '@material-ui/icons'

export const ProjectScreenById = () => {

    const [project, setProject] = useState({})

    const [loaded, setLoaded] = useState(false)

    const { id } = useParams()

    useEffect(()=>{
        db.collection('projects').doc(id).get()
        .then((doc) => {
            if(doc.exists){
                setProject(doc.data())
            }
        })
    },[])
    
    return (
        <>
            {Object.keys(project).length===0
            ?  <Loader/>
            :<>
            <ListGroup style={{ textAlign:'left', backgroundColor:'rgb(31,31,31)', margin:"4rem auto" }} className='p-3' >
                <ListGroup.Item style={{ backgroundColor:'rgb(31,31,31)' }} className='p-3 border-0' >
                    <>
                    {!loaded 
                    ?
                    <>
                    <Skeleton className='mb-5 mx-auto' animation="wave" width={300} height={150} style={{ color:"rgba(255,255,255,.70)", backgroundColor:"rgba(255,255,255,.70)", borderRadius:'1rem' }} variant="rect" /> 
                    <img src={project.image} onLoad={() => setLoaded(true)} style={{ display:"none" }} />
                    </>
                    :<Image src={project.image} fluid style={{ borderRadius:"1rem" }} className='border-0' />
                    }
                    </>
                </ListGroup.Item>
                <ListGroup.Item style={{ backgroundColor:'rgb(31,31,31)', fontSize:'1.5rem' }} className='p-3 mx-auto border-0' >
                    <b>{project.title}</b>
                </ListGroup.Item>
                <ListGroup.Item style={{ backgroundColor:'rgb(31,31,31)' }} className='p-3 border-0' >
                    <b>Description: </b>
                    {project.description.split('.').map(d => (
                        <li key={project.description.split('.').indexOf(d)}>{d}</li>
                    ))}
                </ListGroup.Item>
                <ListGroup.Item style={{ backgroundColor:'rgb(31,31,31)' }} className='p-3 border-0' >
                    <b>Features:</b>
                    {project.features.split('.').map(f => (
                        <li key={project.features.split('.').indexOf(f)}>{f}</li>
                    ))}
                </ListGroup.Item>
                <ListGroup.Item style={{ backgroundColor:'rgb(31,31,31)' }} className='p-3 border-0' >
                    <Badge variant='success' style={{ fontSize:16 }} >Tech Stack Used: </Badge>
                    {project.stack.map(s => (
                        <li key={project.stack.indexOf(s)}>{s}</li>
                    ))}
                </ListGroup.Item>
                <ListGroup.Item style={{ backgroundColor:'rgb(31,31,31)' }} className='p-3 border-0 d-flex mx-auto' >
                    <a target="_blank" rel="noopener noreferrer" href={project.git.slice(0,5)==='https' ? project.git : `/projects/${id}`} style={{ flex:1, width:'100%' }}>
                        <Button variant='dark' style={{ backgroundColor:'rgb(31,31,31)', border:"1px solid rgb(102,102,102)", width:"90%" }}>
                            <GitHubIcon style={{ backgroundColor:'rgb(31,31,31)' }} />
                            <b className='ml-2'>GitHub</b>
                        </Button>
                    </a>
                    {project.link!=='N/A' && project.link!=='Upcoming' && 
                        <a target="_blank" rel="noopener noreferrer" href={project.link!=='N/A' && project.link!=='Upcoming' && project.link} style={{ flex:1, width:'100%' }}>
                            <Button variant='dark' style={{ backgroundColor:'rgb(31,31,31)', border:"1px solid rgb(102,102,102)", width:"90%" }}>
                                <OpenInNewRounded style={{ backgroundColor:'rgb(31,31,31)' }} />
                                <b className='ml-2'>View</b>
                            </Button>
                        </a>}
                </ListGroup.Item>
                <LinkContainer to='/projects' className='mx-auto mt-3'>
                    <Button variant='success' className='rounded py-3 px-5' >
                        Another project
                    </Button>
                </LinkContainer>
            </ListGroup>
            </>
            }
        </>
    )
}
